import React from 'react';
import useNotification from 'hooks/useNotification';
import { Button } from '@mui/material';

interface Props {
  id: string;
  accept?: string;
  buttonLabel: string;
  multiple?: boolean;
  maxSize?: number;
  disabled?: boolean;
  onChange: (files: Array<File>) => void;
}
const Uploader = React.forwardRef((props: Props, ref: any) => {
  const { onFail } = useNotification();
  const {
    id,
    accept,
    buttonLabel,
    multiple = false,
    maxSize = 5,
    disabled,
    onChange,
  } = props;

  return (
    <div className="btn-wrapper">
      <input
        ref={ref}
        accept={accept}
        type="file"
        id={id}
        style={{ display: 'none' }}
        multiple={multiple}
        disabled={disabled}
        onClick={e => {
          e.stopPropagation();
          const element = e.target as HTMLInputElement;
          element.value = '';
        }}
        onChange={e => {
          e.preventDefault();
          e.stopPropagation();
          if (e.target.files) {
            const fileList = e.target.files;
            let result: Array<File> = [];

            for (let i = 0; i < fileList.length; i++) {
              const file = fileList.item(i);
              if (!file) {
                onFail('File upload failed', 'Unknown error');
                continue;
              }
              // size limit
              if (file.size > maxSize * 1024 * 1024) {
                onFail(
                  'File upload failed',
                  `The file exceeds the maximum allowed size (max ${maxSize} MB).`
                );
                continue;
              }
              result = result.concat(file);
            }

            onChange(result);
          }
        }}
      />
      <Button fullWidth variant="outlined" component="label" htmlFor={props.id}>
        {buttonLabel}
      </Button>
    </div>
  );
});

export default Uploader;
